import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { environment } from '../environments/environment';
import { io } from 'socket.io-client';
import { UserService } from './services/user.service';
import { ChatService } from './services/chat.service';
import { MessagingService } from './services/messaging.service';
import { isPlatformBrowser } from '@angular/common';
import { Meta, Title } from '@angular/platform-browser';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
	private authStatusSubs: Subscription;
	title = 'GTI';
	user;
	socket;
	titleNoti = 'push-notification';
 	message;
	isBrowser:boolean=false

	constructor(
		
		@Inject(PLATFORM_ID) private platformId: Object,
		private userService: UserService,
		private chatService: ChatService,
		private router : Router,
		private route : ActivatedRoute,
		private messagingService: MessagingService
	) {
		this.isBrowser = isPlatformBrowser(this.platformId);

		if(this.isBrowser){
			this.socket = io(environment.SOCKET_URL, {
				path: '/socket/',
				transports: ['websocket']
			});
			this.messagingService.requestPermission()
			this.messagingService.receiveMessage()
			this.message = this.messagingService.currentMessage
		}
		this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const navbar = document.querySelector('.navbar-collapse.show');
        if (navbar) {
          navbar.classList.remove('show');
        }
      }
    });
	}

	ngOnInit() {
		if(!this.isBrowser) return 0;

		this.user = this.userService.getUser();
		if(this.user.company_id){
			this.userService.accessRole({id: this.user.company_id}).subscribe(response => {
				if(response.success){
					localStorage.setItem('is_access_role_available', '1');
					localStorage.setItem('access_role', JSON.stringify(response.data.access_role));
					this.userService.setaccessRoleListener();
				}
			});
		}		
		this.authStatusSubs = this.userService.getAuthStatusListener()
			.subscribe((response) => {
				this.user = this.userService.getUser();
				this.loginUser();
			});
		this.socket.on('disconnect', data => {
			this.socket = io(environment.SOCKET_URL, {
				path: '/socket/',
				transports: ['websocket']
			});
		});
		this.socket.on('connect', data => {
			this.loginUser();
		});
		this.socket.on('sidebarcount', data => {
			const url: string = this.router.url;
			data.curruntUrl = url;
			this.userService.setSidebarCountListener(data);
		});
		setInterval(() => {
			this.loginUser();
		});
	}

	loginUser():void{
		if(this.user.id){
			this.socket.emit('join', {id: this.user.id});
		}
	}

}
